import React from "react";
import { Button, Result } from "antd";
import { CONSTANTS } from "../utils/constants";
import { redirectToPlural } from "../utils/common";

const NotFound = () => {
  return (
    <Result
      status="403"
      title={CONSTANTS.UNAUTHORIZED}
      extra={<Button type="primary" onClick={redirectToPlural}>{CONSTANTS.BACKTOPLURAL}</Button>}
    />
  );
};

export default NotFound;
